import { render } from "./ExpiringSecondaryTitle.vue?vue&type=template&id=701193ee"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "701193ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701193ee', script)) {
    api.reload('701193ee', script)
  }
  
  module.hot.accept("./ExpiringSecondaryTitle.vue?vue&type=template&id=701193ee", () => {
    api.rerender('701193ee', render)
  })

}

script.__file = "src/views/services/pageTitles/ExpiringSecondaryTitle.vue"

export default script